import apiClient from "./apiClient";

export const adminAuthService = {
  async adminLogin(email, password) {
    const response = await apiClient.post("/api/admin/login", { email, password });
    const { access_token, admin_user } = response.data;
    localStorage.setItem("admin_access_token", access_token);
    localStorage.setItem("admin_user", JSON.stringify(admin_user));
    return { token: access_token, adminUser: admin_user };
  },

  async adminLogout() {
    try {
      const token = this.getAdminToken();
      if (token) {
        await apiClient.post("/api/admin/logout", {}, {
          headers: { Authorization: `Bearer ${token}` },
        });
      }
    } catch {}
    this.clearAdminSession();
  },

  async verifyAdminToken() {
    const token = this.getAdminToken();
    if (!token) throw new Error("No admin token");
    const response = await apiClient.get("/api/admin/verify", {
      headers: { Authorization: `Bearer ${token}` },
    });
    const adminUser = response.data.admin_user;
    localStorage.setItem("admin_user", JSON.stringify(adminUser));
    return adminUser;
  },

  getCurrentAdminUser() {
    const str = localStorage.getItem("admin_user");
    return str ? JSON.parse(str) : null;
  },

  getAdminToken() {
    return localStorage.getItem("admin_access_token");
  },

  isAdminAuthenticated() {
    return !!this.getAdminToken();
  },

  clearAdminSession() {
    localStorage.removeItem("admin_access_token");
    localStorage.removeItem("admin_user");
  },
};
